/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const approveAccessRequests = /* GraphQL */ `mutation ApproveAccessRequests($input: ApproveAccessRequestsInput!) {
  approveAccessRequests(input: $input) {
    errors {
      code
      message
      request_id
    }
    results {
      request_id
      status
      updated_at
    }
  }
}
` as GeneratedMutation<
  APITypes.ApproveAccessRequestsMutationVariables,
  APITypes.ApproveAccessRequestsMutation
>;
export const cancelAccessRequests = /* GraphQL */ `mutation CancelAccessRequests($input: CancelAccessRequestsInput!) {
  cancelAccessRequests(input: $input) {
    errors {
      code
      message
      request_id
    }
    results {
      request_id
      status
      updated_at
    }
  }
}
` as GeneratedMutation<
  APITypes.CancelAccessRequestsMutationVariables,
  APITypes.CancelAccessRequestsMutation
>;
export const cloneUserAccess = /* GraphQL */ `mutation CloneUserAccess($input: CloneUserAccessInput!) {
  cloneUserAccess(input: $input) {
    access {
      business_group_name
      corp_segment_access
      data_classification_id
      user_type
    }
  }
}
` as GeneratedMutation<
  APITypes.CloneUserAccessMutationVariables,
  APITypes.CloneUserAccessMutation
>;
export const createBusinessGroup = /* GraphQL */ `mutation CreateBusinessGroup($dataClassificationMDJson: BusinessGroupInput) {
  createBusinessGroup(dataClassificationMDJson: $dataClassificationMDJson) {
    business_segments {
      business_segment_data_type
      business_segment_id
      business_segment_name
      business_segment_name_key
      business_segment_values_s3_path
      is_id_column
    }
    corp_segments {
      corp_segment_data_type
      corp_segment_default_value {
        segment_description
        segment_hierarchy
      }
      corp_segment_id
      corp_segment_name
      corp_segment_name_key
      corp_segment_required
      corp_segment_values_s3_path
    }
    data_classification {
      data_classification_description
      data_classification_id
      data_classification_name
      data_classification_short_description
    }
    display_order_id
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    status
  }
}
` as GeneratedMutation<
  APITypes.CreateBusinessGroupMutationVariables,
  APITypes.CreateBusinessGroupMutation
>;
export const createExportForecastDetails = /* GraphQL */ `mutation CreateExportForecastDetails($input: ForecastDetailsInput) {
  createExportForecastDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateExportForecastDetailsMutationVariables,
  APITypes.CreateExportForecastDetailsMutation
>;
export const createExportXVTForecastDetails = /* GraphQL */ `mutation CreateExportXVTForecastDetails($input: XVTForecastDetailsInput) {
  createExportXVTForecastDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateExportXVTForecastDetailsMutationVariables,
  APITypes.CreateExportXVTForecastDetailsMutation
>;
export const createOrUpdateAnnouncementDetails = /* GraphQL */ `mutation CreateOrUpdateAnnouncementDetails($input: [AnnouncementDetailsInput]) {
  createOrUpdateAnnouncementDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateAnnouncementDetailsMutationVariables,
  APITypes.CreateOrUpdateAnnouncementDetailsMutation
>;
export const createOrUpdateCapexActualsDetails = /* GraphQL */ `mutation CreateOrUpdateCapexActualsDetails($input: CapexActualsDetailsInput) {
  createOrUpdateCapexActualsDetails(input: $input) {
    numberOfRecordsUpdated
    total_expense_amount
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateCapexActualsDetailsMutationVariables,
  APITypes.CreateOrUpdateCapexActualsDetailsMutation
>;
export const createOrUpdateCommodityDetails = /* GraphQL */ `mutation CreateOrUpdateCommodityDetails($input: [CommodityDetailsInput]) {
  createOrUpdateCommodityDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateCommodityDetailsMutationVariables,
  APITypes.CreateOrUpdateCommodityDetailsMutation
>;
export const createOrUpdateContactDetails = /* GraphQL */ `mutation CreateOrUpdateContactDetails($input: [ContactDetailsInput]) {
  createOrUpdateContactDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateContactDetailsMutationVariables,
  APITypes.CreateOrUpdateContactDetailsMutation
>;
export const createOrUpdateDMMProductLineCampaigns = /* GraphQL */ `mutation CreateOrUpdateDMMProductLineCampaigns(
  $input: [DMMProductLineCampaignsInput]
) {
  createOrUpdateDMMProductLineCampaigns(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateDMMProductLineCampaignsMutationVariables,
  APITypes.CreateOrUpdateDMMProductLineCampaignsMutation
>;
export const createOrUpdateExpenseTypeDetails = /* GraphQL */ `mutation CreateOrUpdateExpenseTypeDetails($input: [ExpenseTypeDetailsInput]) {
  createOrUpdateExpenseTypeDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateExpenseTypeDetailsMutationVariables,
  APITypes.CreateOrUpdateExpenseTypeDetailsMutation
>;
export const createOrUpdateReportViews = /* GraphQL */ `mutation CreateOrUpdateReportViews(
  $data_classification_id: Int!
  $input: [ReportViewInput!]!
) {
  createOrUpdateReportViews(
    data_classification_id: $data_classification_id
    input: $input
  ) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateReportViewsMutationVariables,
  APITypes.CreateOrUpdateReportViewsMutation
>;
export const createOrUpdateResourcesDetails = /* GraphQL */ `mutation CreateOrUpdateResourcesDetails($input: [ResourcesDetailsInput]) {
  createOrUpdateResourcesDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateResourcesDetailsMutationVariables,
  APITypes.CreateOrUpdateResourcesDetailsMutation
>;
export const createOrUpdateUsefulLifeDetails = /* GraphQL */ `mutation CreateOrUpdateUsefulLifeDetails($input: [UsefulLifeDetailsInput]) {
  createOrUpdateUsefulLifeDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateUsefulLifeDetailsMutationVariables,
  APITypes.CreateOrUpdateUsefulLifeDetailsMutation
>;
export const createOrUpdateUserAccess = /* GraphQL */ `mutation CreateOrUpdateUserAccess($input: [UserAccessInput]) {
  createOrUpdateUserAccess(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateUserAccessMutationVariables,
  APITypes.CreateOrUpdateUserAccessMutation
>;
export const createPlanningCycles = /* GraphQL */ `mutation CreatePlanningCycles($input: [PlanningCycleInput!]!) {
  createPlanningCycles(input: $input) {
    actuals_end_month_id
    actuals_start_month_id
    baseline_scenario {
      baseline_scenario_name
      baseline_scenario_seq_id
    }
    budget_editable_end_month
    budget_editable_start_month
    budget_owner_lock_date
    created_at
    created_by
    data_classification {
      data_classification_description
      data_classification_id
      data_classification_name
      data_classification_short_description
    }
    extended_user_lists
    forecast_data_available
    forecast_end_month_id
    forecast_start_month_id
    is_active
    is_budget_leader_owner_editable
    is_extended
    is_prophecy_enabled
    last_synced_to_prophecy {
      last_synced_to_prophecy
      load_type
    }
    planning_cycle_extended_date
    planning_cycle_lock_date
    planning_cycle_open_date
    planning_cycle_year
    prophecy_actuals_end_month_id
    prophecy_actuals_start_month_id
    prophecy_created_at
    prophecy_created_by
    prophecy_forecast_end_month_id
    prophecy_forecast_start_month_id
    scenario {
      planning_cycle_name
      scenario_id
      scenario_name
    }
    scenario_seq_id
    updated_at
    updated_by
  }
}
` as GeneratedMutation<
  APITypes.CreatePlanningCyclesMutationVariables,
  APITypes.CreatePlanningCyclesMutation
>;
export const createPurchaseRequisitionForBudgetLine = /* GraphQL */ `mutation CreatePurchaseRequisitionForBudgetLine(
  $input: CreatePurchaseRequisitionInput!
) {
  createPurchaseRequisitionForBudgetLine(input: $input) {
    amazon_supplier_display_name
    amazon_supplier_entity_id
    anti_corruption_report_link
    approvals {
      approval_type
      approved_at
      approver_alias
      approver_name
      id
      position
      status
    }
    budget_line_id
    business_justification
    cash_donation_or_grant
    cash_sponsorship
    chart_of_accounts
    chart_of_accounts_name
    community_giving_pre_approval_link
    contains_gift
    country_code
    created_at
    currency_code
    current_approval {
      approval_type
      approved_at
      approver_alias
      approver_name
      id
      position
      status
    }
    dealing_with_government
    description_of_what_purchase_order_includes
    gift_approval_link
    gift_over_limit
    id
    local_currency_total
    marketing_info {
      amazon_approval_request_link
      contract_reviewed_and_signed
      media_channel
      purchase_order_guidelines_met
      vendor_confirmation
    }
    multiyear_po
    name
    ofa_vendor_number
    org_id
    payment_terms
    personal_service_company_engagement
    po_number
    region
    requester_alias
    requester_id
    requisition_lines {
      account_allocations {
        account_code
        cost_center
        percentage
        project_code
      }
      account_code
      budget_line_id
      calendar_year
      commodity_id
      commodity_item
      commodity_name
      commodity_type
      cost_center
      description
      end_date
      estimated_invoice_date
      forecast {
        amount
        month_id
      }
      good_or_service
      id
      line_num
      need_by_date
      payment_schedule
      quantity
      quantity_mode
      start_date
      status
      sub_budget_id
      supplier_entity_id
      supplier_name
      team_budget_id
      total
      unit_of_measurement
      unit_price
      unit_price_in_usd
    }
    send_text_to_supplier
    shipping_address_id
    status
    submitted_at
    supplier_text
    total
    updated_at
  }
}
` as GeneratedMutation<
  APITypes.CreatePurchaseRequisitionForBudgetLineMutationVariables,
  APITypes.CreatePurchaseRequisitionForBudgetLineMutation
>;
export const createScenarioSnapshot = /* GraphQL */ `mutation CreateScenarioSnapshot($scenarioSnapshotJson: ScenarioSnapshotInput) {
  createScenarioSnapshot(scenarioSnapshotJson: $scenarioSnapshotJson) {
    created_at
    created_by
    planning_cycle_name
    planning_cycle_year
    scenario_name
    scenario_seq_id
    scenario_snapshot_id
    scenario_snapshot_name
    scenario_snapshot_note
    scenario_snapshot_time
    status
    updated_at
    updated_by
  }
}
` as GeneratedMutation<
  APITypes.CreateScenarioSnapshotMutationVariables,
  APITypes.CreateScenarioSnapshotMutation
>;
export const createXVTSnapshot = /* GraphQL */ `mutation CreateXVTSnapshot($input: CreateXVTSnapshotInput) {
  createXVTSnapshot(input: $input) {
    created_at
    created_by
    planning_cycle_name
    planning_cycle_year
    scenario_name
    scenario_seq_id
    snapshot_name
    snapshot_note
    snapshot_time
    status
    updated_at
    updated_by
    xvt_snapshot_id
  }
}
` as GeneratedMutation<
  APITypes.CreateXVTSnapshotMutationVariables,
  APITypes.CreateXVTSnapshotMutation
>;
export const exportXVTToHDW = /* GraphQL */ `mutation ExportXVTToHDW($input: ExportXVTToHDWInput) {
  exportXVTToHDW(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.ExportXVTToHDWMutationVariables,
  APITypes.ExportXVTToHDWMutation
>;
export const getAndUpdatePurchaseRequisitionsForBudgetLine = /* GraphQL */ `mutation GetAndUpdatePurchaseRequisitionsForBudgetLine(
  $budget_line_id: String!
) {
  getAndUpdatePurchaseRequisitionsForBudgetLine(
    budget_line_id: $budget_line_id
  ) {
    items {
      amazon_supplier_display_name
      amazon_supplier_entity_id
      anti_corruption_report_link
      approvals {
        approval_type
        approved_at
        approver_alias
        approver_name
        id
        position
        status
      }
      budget_line_id
      business_justification
      cash_donation_or_grant
      cash_sponsorship
      chart_of_accounts
      chart_of_accounts_name
      community_giving_pre_approval_link
      contains_gift
      country_code
      created_at
      currency_code
      current_approval {
        approval_type
        approved_at
        approver_alias
        approver_name
        id
        position
        status
      }
      dealing_with_government
      description_of_what_purchase_order_includes
      gift_approval_link
      gift_over_limit
      id
      local_currency_total
      marketing_info {
        amazon_approval_request_link
        contract_reviewed_and_signed
        media_channel
        purchase_order_guidelines_met
        vendor_confirmation
      }
      multiyear_po
      name
      ofa_vendor_number
      org_id
      payment_terms
      personal_service_company_engagement
      po_number
      region
      requester_alias
      requester_id
      requisition_lines {
        account_allocations {
          account_code
          cost_center
          percentage
          project_code
        }
        account_code
        budget_line_id
        calendar_year
        commodity_id
        commodity_item
        commodity_name
        commodity_type
        cost_center
        description
        end_date
        estimated_invoice_date
        forecast {
          amount
          month_id
        }
        good_or_service
        id
        line_num
        need_by_date
        payment_schedule
        quantity
        quantity_mode
        start_date
        status
        sub_budget_id
        supplier_entity_id
        supplier_name
        team_budget_id
        total
        unit_of_measurement
        unit_price
        unit_price_in_usd
      }
      send_text_to_supplier
      shipping_address_id
      status
      submitted_at
      supplier_text
      total
      updated_at
    }
    total_count
  }
}
` as GeneratedMutation<
  APITypes.GetAndUpdatePurchaseRequisitionsForBudgetLineMutationVariables,
  APITypes.GetAndUpdatePurchaseRequisitionsForBudgetLineMutation
>;
export const markNotificationsRead = /* GraphQL */ `mutation MarkNotificationsRead {
  markNotificationsRead {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.MarkNotificationsReadMutationVariables,
  APITypes.MarkNotificationsReadMutation
>;
export const publishNotification = /* GraphQL */ `mutation PublishNotification($input: PublishNotificationInput!) {
  publishNotification(input: $input) {
    event
    is_persistent
    is_read
    notification_id
    payload
    recipient_aliases
    source
  }
}
` as GeneratedMutation<
  APITypes.PublishNotificationMutationVariables,
  APITypes.PublishNotificationMutation
>;
export const refreshFromLive = /* GraphQL */ `mutation RefreshFromLive($input: RefreshFromLiveInput!) {
  refreshFromLive(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.RefreshFromLiveMutationVariables,
  APITypes.RefreshFromLiveMutation
>;
export const refreshXVTFromLive = /* GraphQL */ `mutation RefreshXVTFromLive($input: RefreshXVTFromLiveInput!) {
  refreshXVTFromLive(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.RefreshXVTFromLiveMutationVariables,
  APITypes.RefreshXVTFromLiveMutation
>;
export const rejectAccessRequests = /* GraphQL */ `mutation RejectAccessRequests($input: RejectAccessRequestsInput!) {
  rejectAccessRequests(input: $input) {
    errors {
      code
      message
      request_id
    }
    results {
      request_id
      status
      updated_at
    }
  }
}
` as GeneratedMutation<
  APITypes.RejectAccessRequestsMutationVariables,
  APITypes.RejectAccessRequestsMutation
>;
export const submitAccessRequests = /* GraphQL */ `mutation SubmitAccessRequests($input: BatchCreateAccessRequestInput!) {
  submitAccessRequests(input: $input) {
    errors {
      code
      data_classification_id
      message
      user_alias
    }
    results {
      business_group_name
      created_at
      data_classification_id
      request_id
      status
      user_alias
    }
  }
}
` as GeneratedMutation<
  APITypes.SubmitAccessRequestsMutationVariables,
  APITypes.SubmitAccessRequestsMutation
>;
export const updateAndExportProjectDetails = /* GraphQL */ `mutation UpdateAndExportProjectDetails($input: ProjectDetailsInput) {
  updateAndExportProjectDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.UpdateAndExportProjectDetailsMutationVariables,
  APITypes.UpdateAndExportProjectDetailsMutation
>;
export const updateBudgetOwnership = /* GraphQL */ `mutation UpdateBudgetOwnership($input: BudgetOwnershipTransferInput) {
  updateBudgetOwnership(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.UpdateBudgetOwnershipMutationVariables,
  APITypes.UpdateBudgetOwnershipMutation
>;
export const updateForecastDetails = /* GraphQL */ `mutation UpdateForecastDetails($forecastDetailsJson: ForecastDetailsInput) {
  updateForecastDetails(forecastDetailsJson: $forecastDetailsJson) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.UpdateForecastDetailsMutationVariables,
  APITypes.UpdateForecastDetailsMutation
>;
export const updatePOActualsDetails = /* GraphQL */ `mutation UpdatePOActualsDetails($input: POActualsDetailsInput) {
  updatePOActualsDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.UpdatePOActualsDetailsMutationVariables,
  APITypes.UpdatePOActualsDetailsMutation
>;
export const upsertXVTForecastDetails = /* GraphQL */ `mutation UpsertXVTForecastDetails($input: XVTForecastDetailsInput) {
  upsertXVTForecastDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.UpsertXVTForecastDetailsMutationVariables,
  APITypes.UpsertXVTForecastDetailsMutation
>;
export const createOrUpdateDmmInvoiceMappings = /* GraphQL */ `mutation CreateOrUpdateDmmInvoiceMappings($input: DmmInvoiceMappingsInput!) {
  createOrUpdateDmmInvoiceMappings(input: $input)
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateDmmInvoiceMappingsMutationVariables,
  APITypes.CreateOrUpdateDmmInvoiceMappingsMutation
>;
export const refreshDmmBreakdownExport = /* GraphQL */ `mutation RefreshDmmBreakdownExport($input: RefreshDmmBreakdownExportInput!) {
  refreshDmmBreakdownExport(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.RefreshDmmBreakdownExportMutationVariables,
  APITypes.RefreshDmmBreakdownExportMutation
>;
export const refreshDmmDetailExport = /* GraphQL */ `mutation RefreshDmmDetailExport($input: RefreshDmmDetailExportInput!) {
  refreshDmmDetailExport(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.RefreshDmmDetailExportMutationVariables,
  APITypes.RefreshDmmDetailExportMutation
>;
export const refreshDmmInvoicedPartition = /* GraphQL */ `mutation RefreshDmmInvoicedPartition(
  $input: RefreshDmmInvoicedPartitionInput!
) {
  refreshDmmInvoicedPartition(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.RefreshDmmInvoicedPartitionMutationVariables,
  APITypes.RefreshDmmInvoicedPartitionMutation
>;
// Manual DMM hedge rows. Both mutations return the AWSJSON scalar (no sub-selection),
// mirroring createOrUpdateDmmInvoiceMappings. Typed variables live in the TS model
// (DmmHedgesInput / DmmHedgeDeleteInput) since these operations are not part of the
// generated API types.
export const createOrUpdateDmmHedge = /* GraphQL */ `mutation CreateOrUpdateDmmHedge($input: DmmHedgesInput!) {
  createOrUpdateDmmHedge(input: $input)
}
`;
export const deleteDmmHedge = /* GraphQL */ `mutation DeleteDmmHedge($input: DmmHedgeDeleteInput!) {
  deleteDmmHedge(input: $input)
}
`;
